module.exports = __webpack_public_path__ + "img/default.597257e2.png";